module.exports = __webpack_public_path__ + "img/fang.c30f2bec.jpg";